module.exports = __webpack_public_path__ + "media/images/main_events/2024/thu-2024-photo-mask-c353032be024530b57e4601ec4022d6e.svg";